(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-aware-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initOne(root) {
    if (!root || root.dataset.inited === 'true') return;
    root.dataset.inited = 'true';

    const track  = root.querySelector('[data-track]');
    const slides = Array.from(track ? track.querySelectorAll('[data-slide]') : []);
    if (!slides.length) return;

    const autoplayImages = (root.dataset.autoplayImages === 'true');
    const imageDuration  = parseInt(root.dataset.imageDuration || '5000', 10);
    const pauseOnHover   = (root.dataset.pauseOnHover === 'true');

    let active = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    if (active < 0) active = 0;

    let timer = null;
    let hovered = false;

    function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }

    function setActive(i) {
      const next = (i + slides.length) % slides.length;

      slides.forEach((s, idx) => {
        s.classList.toggle('is-active', idx === next);
        const v = s.querySelector('video.hero-slider__video');
        if (v) {
          if (idx === next) { v.play && v.play().catch(()=>{}); }
          else {
            try { v.pause && v.pause(); } catch(e){}
            try { v.currentTime = 0; } catch(e){}
          }
        }
      });

      // dots
      const dotsWrap = root.querySelector('[data-dots]');
      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-dot]')) : [];
      dots.forEach(d => d.classList.toggle('is-active', Number(d.dataset.dot) === next));

      active = next;
      armTimer();
      // dynamic height
if (heightMode === 'adaptive') {
  recalcHeight(next);
} else if (heightMode === 'lock_first') {
  // compute once from slide #0
  if (!root.dataset.lockedHeight) {
    recalcHeight(0);
    root.dataset.lockedHeight = '1';
  }
}

    }

    const heightMode = (root.dataset.heightMode || 'fixed'); // 'fixed' | 'adaptive' | 'lock_first'

function getSlideRatio(slide) {
  // 1) If Liquid gave us a ratio on image slides
  const dataRatio = slide.getAttribute('data-ratio');
  if (dataRatio) {
    const r = parseFloat(dataRatio);
    if (!isNaN(r) && r > 0) return r; // width/height from Shopify is "aspect_ratio" (w/h)
  }
  // 2) Try video intrinsic ratio if present
  const v = slide.querySelector('video.hero-slider__video');
  if (v && v.videoWidth && v.videoHeight) {
    return v.videoWidth / v.videoHeight;
  }
  // 3) Fallback to 16:9
  return (16/9);
}

function applyHeightFromRatio(ratio) {
  // ratio is width/height; height px = container width / ratio
  const w = root.clientWidth || root.getBoundingClientRect().width || window.innerWidth;
  const h = w / (ratio || (16/9));
  // apply via CSS var the section already uses
  root.style.setProperty('--hero-min-height', `${Math.round(h)}px`);
}

function recalcHeight(targetIndex) {
  if (heightMode === 'fixed') return; // let your existing var control it
  const index = (typeof targetIndex === 'number') ? targetIndex : active;
  const current = slides[index];
  if (!current) return;
  const ratio = getSlideRatio(current);
  applyHeightFromRatio(ratio);
}


    function goNext() { setActive(active + 1); }
    function goPrev() { setActive(active - 1); }

    function armTimer() {
      clearTimer();
      const current = slides[active];
      const type = current ? current.getAttribute('data-type') : null;

      if (pauseOnHover && hovered) return;
      if (type === 'image' && autoplayImages) {
        timer = setTimeout(goNext, isNaN(imageDuration) ? 5000 : imageDuration);
      }
      // videos rely on 'ended'
    }

    // Delegated clicks (works after DOM swaps)
    function onClick(e) {
      const next = e.target.closest('[data-next]');
      const prev = e.target.closest('[data-prev]');
      const dot  = e.target.closest('[data-dot]');
      if (next) { e.preventDefault(); goNext(); }
      if (prev) { e.preventDefault(); goPrev(); }
      if (dot)  { e.preventDefault(); setActive(Number(dot.dataset.dot) || 0); }
    }
    root.addEventListener('click', onClick);

// Height + auto-advance listeners per video slide
slides.forEach((s, index) => {
  const v = s.querySelector('video.hero-slider__video');
  if (!v) return;

  // Height recalc when the browser learns the real video ratio
  v.addEventListener('loadedmetadata', () => {
    if ((heightMode === 'adaptive' && index === active) ||
        (heightMode === 'lock_first' && index === 0 && !root.dataset.lockedHeight)) {
      recalcHeight(index);
      if (heightMode === 'lock_first') root.dataset.lockedHeight = '1';
    }
  }, { once: true });

  // Go to next slide when video ends
  const onEnded = () => { if (index === active) goNext(); };
  v.addEventListener('ended', onEnded);

  // Fallback for odd browsers where 'ended' may not fire
  const onTimeUpdate = () => {
    if (index !== active) return;
    if (v.duration && v.currentTime >= v.duration - 0.2) goNext();
  };
  v.addEventListener('timeupdate', onTimeUpdate);
});


    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => { hovered = true; clearTimer(); });
      root.addEventListener('mouseleave', () => { hovered = false; armTimer(); });
    }

    setActive(active);
    recalcHeight(active);
window.addEventListener('resize', () => recalcHeight());

  }

  // Init all instances on the page
  document.querySelectorAll('[data-hero-slider]').forEach(initOne);

  // Re-init when the section is reloaded in the editor
  document.addEventListener('shopify:section:load', function(e) {
    const root = e.target && e.target.querySelector && e.target.querySelector('[data-hero-slider]');
    if (root) initOne(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
